// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: packages/content/src/tuning/*.ts
import m0 from './tuning/auth';
import m1 from './tuning/camera';
import m2 from './tuning/chat';
import m3 from './tuning/decor';
import m4 from './tuning/dev';
import m5 from './tuning/fishing';
import m6 from './tuning/fruit';
import m7 from './tuning/house';
import m8 from './tuning/input';
import m9 from './tuning/items';
import m10 from './tuning/light';
import m11 from './tuning/log';
import m12 from './tuning/mail';
import m13 from './tuning/map';
import m14 from './tuning/move';
import m15 from './tuning/museum';
import m16 from './tuning/net';
import m17 from './tuning/news';
import m18 from './tuning/push';
import m19 from './tuning/render';
import m20 from './tuning/safety';
import m21 from './tuning/shop';
import m22 from './tuning/spaces';
import m23 from './tuning/time';
import m24 from './tuning/title';
import m25 from './tuning/town';
import m26 from './tuning/villagers';
import m27 from './tuning/yields';
export const tuningModules = { auth: m0, camera: m1, chat: m2, decor: m3, dev: m4, fishing: m5, fruit: m6, house: m7, input: m8, items: m9, light: m10, log: m11, mail: m12, map: m13, move: m14, museum: m15, net: m16, news: m17, push: m18, render: m19, safety: m20, shop: m21, spaces: m22, time: m23, title: m24, town: m25, villagers: m26, yields: m27 } as const;
